module.exports = __webpack_public_path__ + "img/ionebank_visual.11ca8414.jpg";